<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">HANDMADE WEDDINGS</h1>
<p class="subtitle">MORE THAN 50 CRAFTS TO STYLE and PERSONALIZE YOUR BIG DAY</p>
<p class="author">EUNICE MOYLE, SABRINA MOYLE, AND SHANA FAUST</p>
<p class="center"><em>Photographs by</em> JOSEPH DE LEO</p>
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
<div class="image" id="image2">
<p class="center image_vert"><a id="page_2"></a><img alt="Handmade Weddings" height="80%" src="images/image-2.jpg" width="auto"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003titlepage.vue?54203183